module.exports = __webpack_public_path__ + "img/logo_dark.587d30a5.svg";